module.exports = __webpack_public_path__ + "static/media/clock-notebook-purple.3f7df62b.svg";